
import Lottie from "lottie-react";
import HighFive from "../../workout/animations/high-five.json";
import CustomButton from "../../../common/CustomButton";
import WomanWorkout from "../animations/WomanWorkout.json";

function PersonalInfoPostMessage(props) {
    return (
        <div id="uo-pi-post-message" className="uo-component div-40-60">
            <div id="uo-pi-pm-animation-banner">
                <div id="uo-pi-pm-ab-container">
                    <Lottie className="workout-animation" animationData={WomanWorkout} loop={true} />
                </div>
            </div>

            <div id="uo-pi-pm-text" className="bottom-text-area">
                <h4>Nice to Meet You, {props?.preRegistrationDetails?.personalInfo?.firstName?.trimEnd()}.</h4>
                <h6>Only 50% of adults get the CDC recommended amount of weekly exercise, so let's work together to build a workout routine that gets you moving.</h6>
                <CustomButton className="uo-button active" onClick={props.moveNext}>Continue</CustomButton>
            </div>
        </div>
    );
}

export default PersonalInfoPostMessage;